<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k4e94h/tc-custom/9781685627522.jpg?1705540719255" alt="This image is the cover for the book Two to Nothing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Two to Nothing
      </h1>
      <p class="bookDescription body article font2">
        <p>Arthur Dale is a grownup, a high school English teacher. He tries to meet his students halfway, let them run with their ideas, and then also offer them other ways to look at stories or poems. He sees his students holding back, trying to be cool as they pass through the days in his classroom, but he knows that out in the world they are lively, spirited, and they look around to find others to run with, to engage in their schemes, to push against the limits. Arthur worries -- does he muster his courage and join them in their rebellions, or keep his cool and stay in school? This is an important moment for him. Does he take a chance and run with the pack? Or stay back on the sidelines. Can he do both? What would happen then?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Sarles
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26d7938f